"use strict";
// Warning: this file should not be used serverside
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitQueryString = exports.extractQueryString = exports.removeQueryString = exports.convertMapToQueryString = exports.convertQueryStringToMap = exports.removeRelativePaths = exports.replaceQueryParam = void 0;
function replaceQueryParam(parameterName, value) {
    const regex = new RegExp("([?;&])" + parameterName + "[^&;]*[;&]?");
    const query = window.location.search.replace(regex, "$1").replace(/&$/, "");
    window.location.search = (query.length > 2 ? query + "&" : "?") + (value ? parameterName + "=" + value : "");
}
exports.replaceQueryParam = replaceQueryParam;
function removeRelativePaths(path) {
    const split = path.split("/");
    for (let i = 0; i < split.length; i++) {
        if (split[i] === "..") {
            // count depth
            let depth = 1;
            for (let j = i + 1; j < split.length; j++)
                if (split[j] === "..")
                    depth++;
                else
                    break;
            split.splice(i - depth, depth * 2);
        }
    }
    return split.join("/");
}
exports.removeRelativePaths = removeRelativePaths;
function convertQueryStringToMap(queryString) {
    if (!queryString)
        return {};
    const params = new URLSearchParams(queryString);
    const map = {};
    params.forEach((value, key) => {
        map[key] = value;
    });
    return map;
}
exports.convertQueryStringToMap = convertQueryStringToMap;
function convertMapToQueryString(map) {
    return Object.keys(map)
        .map((key) => {
        return key + "=" + map[key];
    })
        .join("&");
}
exports.convertMapToQueryString = convertMapToQueryString;
function removeQueryString(url) {
    return url.split("?")[0];
}
exports.removeQueryString = removeQueryString;
function extractQueryString(url) {
    return url.split("?")[1];
}
exports.extractQueryString = extractQueryString;
function splitQueryString(url) {
    return { url: removeQueryString(url), queryString: extractQueryString(url) };
}
exports.splitQueryString = splitQueryString;
